module.exports = __webpack_public_path__ + "static/media/JB_icon.8e5d5cb2.ico";